const INVESTOR_CONTENT_MODAL_TRANSITION_DURATION = 300;

class InvestorContentModal extends ModalBase {
  get modalTransition() {
    return {
      overlayOpenClasses: ['opacity-100'],
      overlayClosedClasses: ['opacity-0'],
      panelOpenClasses: ['opacity-100', 'max-lg:translate-y-0', 'lg:scale-100'],
      panelClosedClasses: ['opacity-0', 'max-lg:translate-y-full', 'lg:scale-95'],
      transitionDuration: INVESTOR_CONTENT_MODAL_TRANSITION_DURATION,
    };
  }

  constructor() {
    super();
    this.previousActiveElement = null;
    this.isOpen = false;
    this.focusTrapHandler = null;
  }

  connectedCallback() {
    this.overlay = this.querySelector('[data-investor-content-overlay]');
    this.panel = this.querySelector('[data-investor-content-panel]');
    this.titleEl = this.querySelector('[data-investor-content-title]');
    this.bodyEl = this.querySelector('[data-investor-content-body]');

    this.overlay?.addEventListener('click', () => this.close());

    this.addEventListener('click', (event) => {
      if (event.target.closest('[data-investor-content-close]')) this.close();
    });

    this.handleKeydown = (event) => {
      if (event.key === 'Escape' && this.isOpen) this.close();
    };
    document.addEventListener('keydown', this.handleKeydown);

    this.handleTriggerClick = (event) => {
      const trigger = event.target.closest('[data-investor-content-open]');
      if (!trigger) return;
      event.preventDefault();
      this.openFromTrigger(trigger);
    };
    document.addEventListener('click', this.handleTriggerClick);
  }

  disconnectedCallback() {
    document.removeEventListener('keydown', this.handleKeydown);
    document.removeEventListener('click', this.handleTriggerClick);
    this.removeTrapFocus();
  }

  openFromTrigger(trigger) {
    const source = document.getElementById(trigger.dataset.investorContentTarget);
    if (!source) return;

    if (this.titleEl) this.titleEl.textContent = source.dataset.title ?? '';
    if (this.bodyEl) {
      this.bodyEl.replaceChildren(...[...source.childNodes].map((node) => node.cloneNode(true)));
      this.bodyEl.scrollTop = 0;
    }

    this.openModal();
  }

  close() {
    this.closeModal();
  }
}

if (!customElements.get('investor-content-modal')) {
  customElements.define('investor-content-modal', InvestorContentModal);
}
